export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtSklad';
export const NAME = 'Sklad';
